import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

import type { IError } from '../../types';
import type {
  IPaginationRequest,
  IMultiNumericCreateRequest,
  IDeleteRequest,
  IStringResponse,
  IMultiNumericResponse,
} from '../../types/IApiTypes';

export const FeatureApi = {
  //Get all multi-numeric feaures from the api
  //Also return the filtered features based on the searchKey and page limit by passing query parameters
  fetchMultiNumericFeatures: async (payload: IPaginationRequest, dispatch: Dispatch) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(payload.page),
      [EUrlParams.Limit]: String(payload.limit),
    });
    if (payload.searchCode) {
      queryParams.set(EUrlParams.Search, payload.searchCode);
    }

    return AxiosClient.post(`/feature/v1/read?${queryParams}`, {})
      .then((response: IMultiNumericResponse) => {
        return handlePaginatedData(response, payload);
      })
      .catch((err: IError) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: payload.page, searchKey: payload.searchCode },
          EAction.Read,
          EApiType.MultiNumericFeatureKey
        );
      });
  },

  //Create the new multi numeric feature
  createMultiNumericFeature: async (action: IMultiNumericCreateRequest, dispatch: Dispatch) => {
    return AxiosClient.post('/feature/v1/create', action.request)
      .then((response: IStringResponse) => {
        return handleSuccess(response);
      })
      .catch((err: IError) => {
        return handleError(dispatch, err, EAction.Create);
      });
  },

  //update the existing multi numeric feature
  updateMultiNumericFeature: async (action: IMultiNumericCreateRequest, dispatch: Dispatch) => {
    return AxiosClient.post('/feature/v1/update', action.request)
      .then((response: IStringResponse) => {
        return handleSuccess(response);
      })
      .catch((err: IError) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  //delete the existing multi numeric feature
  deleteMultiNumericFeatures: async (action: IDeleteRequest, dispatch: Dispatch) => {
    return AxiosClient.post('/feature/v1/delete', action.request)
      .then((response: IStringResponse) => {
        return handleSuccess(response);
      })
      .catch((err: IError) => {
        return handleError(dispatch, err);
      });
  },

  //fetch the sigle multi numeric feature by search Key
  fetchMultiNumericFeatureDetails: async (payload: IPaginationRequest, dispatch: Dispatch) => {
    const queryParams = `${EUrlParams.Search}=${payload?.searchCode ?? ''}`;
    return AxiosClient.post(`/feature/v1/read?${queryParams}`, {})
      .then((response: IMultiNumericResponse) => {
        return handleSuccess(response);
      })
      .catch((err: IError) => {
        return handleError(dispatch, err, EAction.Get);
      });
  },
};
